import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingColumns, faCalculator,faCreditCard,faLockOpen,faUser } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { update_bank_details, update_bank_redu } from "../../features/userSlice";
import {  faGooglePay } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";

const AddBankDetails = () => {
  
const {Info}=useSelector((state)=>state.users);
const dispatch=useDispatch();
const navigate=useNavigate();
const [bankData,setbankData]=useState({
    ifscCode:Info?.bank_details?.ifsc_code,
    ac_num:Info?.bank_details?.account_number,
    bank_name:Info?.bank_details?.bank_name,
    ac_holder_name:Info?.bank_details?.account_holder_name,
    paytm:Info?.paytm,
    gpay:Info?.googlepay,
    phonepay:Info?.phonepay,
});

const handleSubmit = async(e) => {

        msgAccessPromt({dispatch,msg:'LOADING',error:true});
     
        e.preventDefault();
        let dataSet = new FormData();

       
        
        dataSet.append('ifsc_code',bankData.ifscCode);
        dataSet.append('phone_number',Info?.phone_number);
        dataSet.append('account_number',bankData?.ac_num);
        dataSet.append('bank_name',bankData?.bank_name);
        dataSet.append('account_holder_name', bankData?.ac_holder_name);
        if(bankData.paytm){dataSet.append('paytm', bankData?.paytm);}
        if(bankData.phonepay){dataSet.append('phonepay', bankData?.phonepay);}
        if(bankData.gpay){dataSet.append('googlepay', bankData?.gpay);}
        
        

        try {
            const data = await dispatch(update_bank_details(dataSet)).unwrap(); // Unwrap to get the resolved value
            if(data.success){
                msgAccessPromt({dispatch,error:false,msg:data.msg});
                navigate('/home');
            }else{
                msgAccessPromt({dispatch,error:true,msg:data.msg});
            }
        } catch (error) {
            console.error('API Error:', error);
            msgAccessPromt({dispatch,error:true,msg:'Api Error'});

        }
        
    };

return (
        <div className="all_bids" style={{padding:'4%'}}>
            
            <h4 style={{textAlign:'left',padding:'14px'}}>Bank Details</h4><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faLockOpen} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="text" value={bankData.ifscCode} onChange={(e)=>setbankData({...bankData,ifscCode:e.target.value.toUpperCase()})} placeholder="IFSC Code" />
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCalculator} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={bankData.ac_num} onChange={(e)=>setbankData({...bankData,ac_num:e.target.value})} placeholder="Account number" />
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faBuildingColumns} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="text" value={bankData.bank_name} onChange={(e)=>setbankData({...bankData,bank_name:e.target.value})} placeholder="Bank name" />
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faUser} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="text" value={bankData.ac_holder_name} onChange={(e)=>setbankData({...bankData,ac_holder_name:e.target.value})} placeholder="Account holder name" />
            </div><br/>

            <div className="input-group">
                <i><FontAwesomeIcon icon={faGooglePay} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={bankData.gpay} onChange={(e)=>setbankData({...bankData,gpay:e.target.value})} placeholder="Google pay Number" />
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCreditCard} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={bankData.phonepay} onChange={(e)=>setbankData({...bankData,phonepay:e.target.value})} placeholder="Phone Pay number" />
            </div><br/>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCreditCard} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={bankData.paytm} onChange={(e)=>setbankData({...bankData,paytm:e.target.value})} placeholder="Paytm Number" />
            </div><br/>
            <button style={{marginLeft:'9%',width:'80%'}} onClick={handleSubmit} className="continue-button">SUBMIT</button>
            <br/><br/><br/>
        </div>
    );
};

export default AddBankDetails;
